import { PlayersWidgetsContainerStyle } from "app/components/React/TopSites/DomainsTable/TopPlayersTableOverview/PlayersWidgetsContainer.styles";
import { RisingPlayers } from "app/pages/industry-analysis/players/rising-and-declining-players/RisingPlayers";
import { DecliningPlayers } from "app/pages/industry-analysis/players/rising-and-declining-players/DecliningPlayers";
import type { FC } from "react";
import { useCallback } from "react";
import type { IMarketPlayersState } from "app/pages/industry-analysis/players/types";
import { translate } from "app/filters/i18nFilter";
import { useCurrentStateAndParams } from "@uirouter/react";
import { EPlayersType } from "./types";
import { getIsPeriodOverPeriodChangeAvailable } from "app/pages/industry-analysis/players/utils/getIsPeriodOverPeriodChangeAvailable";
import DurationService from "app/services/DurationService";

interface IRisingAndDecliningPlayers {
    state: IMarketPlayersState;
}

export const RisingAndDecliningPlayers: FC<IRisingAndDecliningPlayers> = (props) => {
    const { state } = props;
    const { risingAndDecliningRawData: rawData, isLoading } = state;
    const { params } = useCurrentStateAndParams();
    const isPeriodOverPeriod = DurationService.isPeriodOverPeriod();
    const isYearOverYear = params.comparedDuration === "12m";

    // provides noData message for spacial casses:
    const getNoData = useCallback(
        (playersType: EPlayersType) => {
            const isPeriodOverPeriodChangeAvailable = getIsPeriodOverPeriodChangeAvailable();
            const isNoData = !isPeriodOverPeriodChangeAvailable;
            // A specific no data message should be displayed
            // when the period selected doesn't support a period over period change
            if (isNoData) {
                if (playersType === EPlayersType.RISING) {
                    return {
                        noDataTitle: translate("market.research.players.rising.no.data.for.period"),
                        noDataSubtitle: translate("market.research.players.rising.no.data.for.period.subtitle"),
                    };
                } else {
                    return {
                        noDataTitle: translate("market.research.players.declining.no.data.for.period"),
                        noDataSubtitle: translate("market.research.players.declining.no.data.for.period.subtitle"),
                    };
                }
            }
            return {};
        },
        [params],
    );
    return (
        <PlayersWidgetsContainerStyle>
            <RisingPlayers
                rawData={rawData}
                isLoading={isLoading}
                isPeriodOverPeriod={isPeriodOverPeriod}
                isYearOverYear={isYearOverYear}
                noData={getNoData(EPlayersType.RISING)}
            />
            <DecliningPlayers
                rawData={rawData}
                isLoading={isLoading}
                isPeriodOverPeriod={isPeriodOverPeriod}
                isYearOverYear={isYearOverYear}
                noData={getNoData(EPlayersType.DECLINING)}
            />
        </PlayersWidgetsContainerStyle>
    );
};
